import React, { useEffect, useState } from "react";
import * as ownerApi from "../../api/payroll/payrollReportApi";
import * as portalApi from "../../api/payroll/payrollReportPortalApi";
import {
  useToast
} from "../../context/ToastContext";

const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function YearEndSummary({ isPortal = false }) {
  const api = isPortal ? portalApi : ownerApi;
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.getYearEndSummary(year);
      setData(res?.data || res);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [year, isPortal]);

  const totals = data?.yearTotals || {};

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Year-end Payroll Summary</h1>
        <select className="border rounded-lg px-3 py-2" value={year} onChange={(e) => setYear(Number(e.target.value))}>
          {[0, 1, 2].map((i) => {
            const y = new Date().getFullYear() - i;
            return <option key={y} value={y}>{y}</option>;
          })}
        </select>
      </div>
      
      {loading && <p>Loading...</p>}
      {data && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6 text-sm">
            <div className="bg-white dark:bg-neutral-900 border rounded-lg p-3"><p className="text-neutral-500 dark:text-neutral-400">Gross</p><p className="font-semibold">₹{Number(totals.totalGrossPay || 0).toLocaleString()}</p></div>
            <div className="bg-white dark:bg-neutral-900 border rounded-lg p-3"><p className="text-neutral-500 dark:text-neutral-400">Deductions</p><p className="font-semibold">₹{Number(totals.totalDeductions || 0).toLocaleString()}</p></div>
            <div className="bg-white dark:bg-neutral-900 border rounded-lg p-3"><p className="text-neutral-500 dark:text-neutral-400">Net</p><p className="font-semibold">₹{Number(totals.totalNetPay || 0).toLocaleString()}</p></div>
            <div className="bg-white dark:bg-neutral-900 border rounded-lg p-3"><p className="text-neutral-500 dark:text-neutral-400">Overtime</p><p className="font-semibold">₹{Number(totals.totalOvertimePay || 0).toLocaleString()}</p></div>
            <div className="bg-white dark:bg-neutral-900 border rounded-lg p-3"><p className="text-neutral-500 dark:text-neutral-400">Statutory</p><p className="font-semibold">₹{Number(totals.totalStatutoryDeductions || 0).toLocaleString()}</p></div>
          </div>
          <div className="bg-white dark:bg-neutral-900 border rounded-xl overflow-hidden">
            <table className="min-w-full text-sm">
              <thead className="bg-neutral-50 dark:bg-neutral-900 dark:bg-neutral-950">
                <tr>
                  <th className="text-left px-4 py-3">Month</th>
                  <th className="text-right px-4 py-3">Staff</th>
                  <th className="text-right px-4 py-3">Gross</th>
                  <th className="text-right px-4 py-3">Deductions</th>
                  <th className="text-right px-4 py-3">Net</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {(data.months || []).map((m) => (
                  <tr key={m.month}>
                    <td className="px-4 py-3">{MONTHS[m.month] || m.month}</td>
                    <td className="px-4 py-3 text-right">{m.totalStaffCount}</td>
                    <td className="px-4 py-3 text-right">₹{Number(m.totalGrossPay || 0).toLocaleString()}</td>
                    <td className="px-4 py-3 text-right">₹{Number(m.totalDeductions || 0).toLocaleString()}</td>
                    <td className="px-4 py-3 text-right font-medium">₹{Number(m.totalNetPay || 0).toLocaleString()}</td>
                  </tr>
                ))}
                {!(data.months || []).length && (
                  <tr><td colSpan={5} className="px-4 py-8 text-center text-neutral-500 dark:text-neutral-400">No published runs for this year</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
